$(document).ready(function () {
  // header sticky
  $(window).scroll(function () {
    if ($(this).scrollTop() > 40) {
      $(".header_main").addClass("menufixed");
      $("body").addClass("header-fixed");
      $("body").addClass("cart-top");
    } else {
      $(".header_main").removeClass("menufixed");
      $("body").removeClass("header-fixed");
      $("body").removeClass("cart-top");
    }
  });

  $(".sidebarIconToggle").click(function () {
    $(this).toggleClass("sidebarclose");
    $(".sidebar").toggle();
    $(".sidebar").toggleClass("sidebaranimat");
    $("body").toggleClass("bodybarfixed");
  });

  var swiper = new Swiper(".announce-inner", {
    slidesPerView: 1,
    loop: true,
    speed: 1000,
    draggable: true,
    autoplay: {
      delay: 1000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".hero-pagination",
      clickable: true,
    },
  });

  var swiperContainer = document.querySelector(".hero-slider");
  if ($(".hero-slider .swiper-slide").length > 0) {
    var numberOfSlides =
      swiperContainer.querySelectorAll(".swiper-slide").length;

    var swiperConfig = {
      slidesPerView: 1,
      loop: numberOfSlides > 1, // Loop only if there's more than one slide
      speed: 800,
      draggable: true,
      centeredSlides: true,
      autoplay: enableAutoplay
        ? {
            delay: 6000,
            disableOnInteraction: false,
          }
        : false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".hero-pagination",
        clickable: true,
      },
    };

    if (numberOfSlides > 1) {
      swiperConfig.autoplay = enableAutoplay
        ? {
            delay: 6000,
            disableOnInteraction: false,
          }
        : false;
    } else {
      swiperConfig.autoplay = false; // Disable autoplay if there's only one slide
    }
  }
  var swiper = new Swiper(".hero-slider", swiperConfig);

  // feature-slider
  var swiper = new Swiper(".feature-swiper-slider", {
    slidesPerView: 4,
    loop: false,
    centeredSlides: false,
    draggable: true,
    spaceBetween: 28,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    // autoplay: {
    //   delay: false,
    //   disableOnInteraction: false,
    // },
    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 28,
        loop: false,
      },
      768: {
        slidesPerView: 2.5,
        spaceBetween: 28,
        loop: true,
      },
      575: {
        slidesPerView: 2.5,
        spaceBetween: 28,
        loop: true,
      },
      414: {
        slidesPerView: 1.2,
        spaceBetween: 30,
        loop: true,
      },
      320: {
        slidesPerView: 1.2,
        spaceBetween: 30,
        loop: true,
      },
    },
  });

  // blog slider
  var swiper = new Swiper(".blog-slider", {
    slidesPerView: 1,
    loop: true,
    speed: 1000,
    draggable: true,
    autoplay: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".blog-pagination",
      clickable: true,
    },
  });

  //Multi product slider
  var swiper = new Swiper(".multi-pro-swiper", {
    slidesPerView: 4,
    loop: false,
    centeredSlides: false,
    draggable: true,
    spaceBetween: 50,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    // autoplay: {
    //   delay: false,
    //   disableOnInteraction: false,
    // },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 50,
        loop: false,
      },

      768: {
        slidesPerView: 2.3,
        spaceBetween: 30,
        loop: true,
      },
      575: {
        slidesPerView: 2.3,
        spaceBetween: 20,
        loop: true,
      },
      414: {
        slidesPerView: 1.3,
        spaceBetween: 20,
        loop: true,
      },
      320: {
        slidesPerView: 1.2,
        spaceBetween: 20,
        loop: true,
      },
    },
  });
  var swiper = new Swiper(".how_it_works .multi-pro-swiper", {
    slidesPerView: 3,
    centeredSlides: false,
    draggable: true,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
        loop: false,
      },

      768: {
        slidesPerView: 2,
        spaceBetween: 20,
        loop: true,
      },
      575: {
        slidesPerView: 2,
        spaceBetween: 20,
        loop: true,
      },
      414: {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
      },
    },
  });

  // Insta block slider
  var swiper = new Swiper(".insta-block-slider", {
    slidesPerView: 4,
    loop: false,
    draggable: true,
    spaceBetween: 36,
    navigation: {
      nextEl: ".swiper-btn-next",
      prevEl: ".swiper-btn-prev",
    },
    // autoplay: {
    //   delay: false,
    //   disableOnInteraction: false,
    // },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 36,
        loop: false,
      },

      768: {
        slidesPerView: 3,
        spaceBetween: 30,
        loop: false,
      },
      575: {
        slidesPerView: 3,
        spaceBetween: 20,
        loop: false,
      },
      414: {
        slidesPerView: 1.2,
        spaceBetween: 20,
        loop: false,
      },
      320: {
        slidesPerView: 1.2,
        spaceBetween: 20,
        loop: false,
      },
    },
  });

  //super food product slider
  var swiper = new Swiper(".super-food-product-slider", {
    slidesPerView: 6,
    loop: false,
    draggable: true,
    centeredSlides: false,
    spaceBetween: 47,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    // autoplay: {
    //   delay: false,
    //   disableOnInteraction: false,
    // },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      1440: {
        slidesPerView: 6,
        spaceBetween: 47,
        loop: false,
      },
      1280: {
        slidesPerView: 6,
        spaceBetween: 47,
        loop: false,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 47,
        loop: false,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 47,
        loop: false,
      },
      575: {
        slidesPerView: 2,
        spaceBetween: 47,
        loop: false,
      },
      414: {
        slidesPerView: 1,
        spaceBetween: 47,
        loop: false,
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 47,
        loop: false,
      },
    },
  });

  // LOGO Slider
  var swiper = new Swiper(".logo-slider", {
    slidesPerView: "auto",
    spaceBetween: 95,
    centeredSlides: true,
    speed: 3000,
    loop: true,
    grabCursor: true,
    mousewheelControl: true,
    keyboardControl: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      1024: {
        slidesPerView: 6.5,
        spaceBetween: 60,
      },
      768: {
        slidesPerView: 4.5,
        spaceBetween: 40,
      },
      575: {
        slidesPerView: 4.5,
        spaceBetween: 40,
      },
      414: {
        slidesPerView: 3.5,
        spaceBetween: 40,
      },
      320: {
        slidesPerView: 2.5,
        spaceBetween: 40,
      },
    },
  });

  // DO not delete this commented script

  // // face Slider
  // var swiperface = new Swiper(".face-slider", {
  //   slidesPerView: 'auto',
  //   spaceBetween: 20,
  //   centeredSlides: true,
  //   speed: 3000,
  //   loop: true,
  //   grabCursor: true,
  //   mousewheelControl: true,
  //   keyboardControl: true,
  //   autoplay:false,
  //   clickable: true,
  //   slideToClickedSlide: true,
  //   watchSlidesVisibility: true,
  //   breakpoints: {
  //     1024: {
  //       slidesPerView: 5.8,
  //       spaceBetween: 20,
  //     },
  //     768: {
  //       slidesPerView: 4.5,
  //       spaceBetween: 20,
  //     },
  //     575: {
  //       slidesPerView: 3.5,
  //       spaceBetween: 20,
  //     },
  //     414: {
  //       slidesPerView: 2.5,
  //       spaceBetween: 20,
  //     },
  //     320: {
  //       slidesPerView: 2.5,
  //       spaceBetween: 20,
  //     },
  //   },
  // });

  // $('.face-slider .product-image img').on('click', function() {
  //   var datadisplay = $(this).attr("data-varhand");
  //   $('input[type="radio"][data-swatch="'+datadisplay+'"]').trigger('click');
  // });

  // // swatch Slider
  // var swiperface = new Swiper(".swatch-slider", {
  //   slidesPerView: 5.8,
  //   spaceBetween: 20,
  //   centeredSlides: true,
  //   speed: 3000,
  //   loop: true,
  //   grabCursor: true,
  //   mousewheelControl: true,
  //   keyboardControl: true,
  //   autoplay:false,
  //   clickable: true,
  //   slideToClickedSlide: true,
  //   watchSlidesVisibility: true,
  //   breakpoints: {
  //     1024: {
  //       slidesPerView: 5.8,
  //       spaceBetween: 20,
  //     },
  //     768: {
  //       slidesPerView: 4.5,
  //       spaceBetween: 20,
  //     },
  //     575: {
  //       slidesPerView: 3.5,
  //       spaceBetween: 20,
  //     },
  //     414: {
  //       slidesPerView: 2.5,
  //       spaceBetween: 20,
  //     },
  //     320: {
  //       slidesPerView: 2.5,
  //       spaceBetween: 20,
  //     },
  //   },
  // });

  // GIFT CARD RECOMMENDED SLIDER
  setTimeout(() => {
    var swiper = new Swiper(".giftcard-slider", {
      slidesPerView: 4,
      spaceBetween: 47,
      //centeredSlides: true,
      speed: 3000,
      loop: true,
      draggable: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      autoplay: {
        delay: 2500,
        //disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        1024: {
          slidesPerView: 4,
          spaceBetween: 47,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        575: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        414: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
      },
    });
  }, 5000);

  $(".swatch-slider .product-image img").on("click", function () {
    var datadisplay = $(this).attr("data-varhand");
    $('input[type="radio"][data-swatch="' + datadisplay + '"]').trigger(
      "click",
    );
  });
  // accordion FOR FAQ
  $(".set > a").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".content").slideUp(200);
      $(".set > a i").removeClass("fa-angle-up").addClass("fa-angle-down");
    } else {
      $(".set > a i").removeClass("fa-angle-up").addClass("fa-angle-down");
      $(this).find("i").removeClass("fa-angle-down").addClass("fa-angle-up");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this).siblings(".content").slideDown(200);
    }
  });

  // Press page load more btn

  $(function () {
    $(".press-box1").slice(0, 3).show();
    $(".press-box2").slice(0, 3).show();
    $("body").on("click touchstart", ".load-more", function (e) {
      e.preventDefault();
      $(".press-box1:hidden").slice(0, 3).slideDown();
      $(".press-box2:hidden").slice(0, 3).slideDown();
      if (
        $(".press-box1:hidden").length == 0 &&
        $(".press-box2:hidden").length == 0
      ) {
        $(".load-more").css("visibility", "hidden");
      }
      $("html,body").animate(
        {
          scrollTop: $(this).offset().top,
        },
        1000,
      );
    });
  });

  // mobile sub-menu hide show
  $(".menu-drawer__menu .ctm_click").on("click", function () {
    if ($(this).children(".drop-box-ctm").hasClass("submenu-open-ctm")) {
      $(this).children(".drop-box-ctm").removeClass("submenu-open-ctm");
      setTimeout(function () {
        $(this).children(".drop-box-ctm").removeAttr("open");
      }, 1000);
    } else {
      $(".menu-drawer__menu .ctm_click .drop-box-ctm").removeClass(
        "submenu-open-ctm",
      );
      $(".menu-drawer__menu .ctm_click .drop-box-ctm").removeAttr("open");
      $(this).children(".drop-box-ctm").addClass("submenu-open-ctm");
      $(this).children(".drop-box-ctm").attr("open");
    }
  });

  // blog page filter and search
  $(function () {
    $("#BlogTagFilter").on("change", function () {
      var url = $(this).val(); // get selected value
      if (url) {
        // require a URL
        window.location = url; // redirect
      }
      return false;
    });
  });

  $(
    (function () {
      var searchTerm, panelContainerId;
      $("#blog_search_bar").on("change keyup", function () {
        searchTerm = $(this).val();
        $("#blog_post > .panel_ctm").each(function () {
          panelContainerId = "#" + $(this).attr("id");
          $.extend($.expr[":"], {
            contains: function (elem, i, match, array) {
              return (
                (elem.textContent || elem.innerText || "")
                  .toLowerCase()
                  .indexOf((match[3] || "").toLowerCase()) >= 0
              );
            },
          });
          $(panelContainerId + ":not(:contains(" + searchTerm + "))").hide();
          $(panelContainerId + ":contains(" + searchTerm + ")").show();
        });
      });
    })(),
  );

  // press page search

  $(
    (function () {
      var searchTermPress, panelContainerIdPress;
      $("#press_search_bar").on("change keyup", function () {
        searchTermPress = $(this).val();
        $("#press_ctm > .panel_ctm").each(function () {
          panelContainerIdPress = "#" + $(this).attr("id");
          $.extend($.expr[":"], {
            contains: function (elem, i, match, array) {
              return (
                (elem.textContent || elem.innerText || "")
                  .toLowerCase()
                  .indexOf((match[3] || "").toLowerCase()) >= 0
              );
            },
          });

          var check_length = $(
            panelContainerIdPress + ":not(:contains(" + searchTermPress + "))",
          ).hide().length;
          if (check_length == 1) {
            $(".no_data").removeClass("hidden");
            $(".load-more").addClass("hidden");
          } else {
            $(".no_data").addClass("hidden");
            $(".load-more").removeClass("hidden");
          }
          $(
            panelContainerIdPress + ":not(:contains(" + searchTermPress + "))",
          ).hide();
          $(
            panelContainerIdPress + ":contains(" + searchTermPress + ")",
          ).show();
        });
      });
    })(),
  );

  //press drop down

  $("#pressImgFilter").on("change", function () {
    var get_val = $(this).val();

    $("#press_ctm .panel_ctm").each(function () {
      var img_alt = $(this).find("img").attr("alt");
      if (get_val == "all") {
        $(".press-box").slice(0, 6).show();
        $(".load-more-press").css("display", "block");
      } else if (img_alt.includes(get_val)) {
        $(this).css("display", "block");
        $(".load-more-press").css("display", "none");
      } else {
        $(this).css("display", "none");
      }
    });
  });

  $(function () {
    $(".press-box").slice(0, 6).show();
    $("body").on("click touchstart", ".load-more-press", function (e) {
      e.preventDefault();
      $(".press-box:hidden").slice(0, 3).slideDown();
      if ($(".press-box:hidden").length == 0) {
        $(".load-more-press").css("visibility", "hidden");
      }
      $("html,body").animate(
        {
          scrollTop: $(this).offset().top,
        },
        1000,
      );
    });
  });

  // Open Popup

  $(".login_popup").click(function () {
    $(".customer-account").removeClass("hidden");
  });

  $(".c-close").click(function () {
    $(".customer-account").addClass("hidden");
  });

  // Close Popup when Click outside
  $(".popup_account")
    .on("click", function () {
      $(".popup_account").fadeOut(300);
    })
    .children()
    .click(function () {
      return false;
    });

  // login popup

  $(".login_popup").click(function () {
    $(".customer-account").removeClass("hidden");
    $("body").toggleClass("modal-overlay-active");
    $(".modal-overlay").css("background", "rgb(0, 0, 0, 0.5)");
    $("body").addClass("modal-overflow");
  });

  $(".c-close").click(function () {
    $(".customer-account").addClass("hidden");
    $("body").removeClass("modal-overlay-active");
    $("body").removeClass("modal-overflow");
  });

  $(".modal-overlay").click(function () {
    $(".customer-account").addClass("hidden");
    $("body").toggleClass("modal-overlay-active");
    $("body").removeClass("modal-overflow");
  });

  $("#login-none").click(function () {
    $(".login-cta").addClass("d-none");
    $(".reset-password").removeClass("d-none");
  });

  $("#recover-cancel").click(function () {
    $(".login-cta").removeClass("d-none");
    $(".reset-password").addClass("d-none");
  });

  $(".tab-heading ul li a").click(function () {
    var tab_idd = $(this).attr("data-tab");

    $(".tab-heading ul li a").removeClass("current");
    $(".account-tab.tab-pane").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_idd).addClass("current");
  });

  // PDP tab for faces and swatches
  $(".tab-heading-shade ul li a").click(function () {
    var tab_id = $(this).attr("data-tab");

    $(".tab-heading-shade ul li a").removeClass("current");
    $(".pdp.tab-pane").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });

  $("#login-none").click(function () {
    $(".customer.login .reset-password").addClass("current");

    $(".login-cta").css("display", "none");
  });
  $("#recover-cancel").click(function () {
    $(".customer.login .reset-password").removeClass("current");
    $(".login-cta").css("display", "block");
  });

  // Scroll Top Account
  $("#recover-scroll-button").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 300), !1;
  });
  $(".header__search").click(function () {
    $("body").toggleClass("searchmodal-overlay");
  });

  //open cart drawer when click on shop now
  $(".fc-form-submit").on("click", function (e) {
    $("body").addClass("overflow-hidden");
    $("cart-drawer").addClass("active");
  });

  //  superfood selected dropbox

  var get_url = window.location.pathname;
  var get_page = get_url.split("/")[2];

  $(".superfood_filter option").each(function () {
    var option_val = $(this).val();
    var option_val_get = option_val.split("/")[4];
    if (option_val_get == get_page) {
      $(this).prop("selected", "selected");
    }
  });

  // PDP accordian
  $(" .info_ctm > a").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".accrde-content").slideUp(200);
    } else {
      $(" .info_ctm > a").removeClass("active");
      $(this).addClass("active");
      $(".accrde-content").slideUp(200);
      $(this).siblings(".accrde-content").slideDown(200);
    }
  });

  // PDP  show/hide ingredents
  $(".hide_ingredients").on("click", function () {
    $(".show_ingredients").trigger("click");
    $(".hide_ingredients").addClass("hidden");
    $(".show_ingredients").removeClass("hidden");
  });

  $(".show_ingredients").on("click", function () {
    $(".ingredients_wrapper").toggleClass("hidden");
    $(".accored-block").toggleClass("accored-ingredient");
    $(".hide_ingredients").removeClass("hidden");
    $(".show_ingredients").addClass("hidden");
  });

  // blog ative all tab with pagination

  if (window.location.href == "https://yensa.com/blogs/news") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=1") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=2") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=3") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=4") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=5") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=6") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=7") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=8") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=9") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=10") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=11") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=12") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=14") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=15") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=16") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=17") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=18") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=19") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=20") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=21") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=22") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=23") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=24") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=25") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=26") {
    $(document).find(".uppercase-letter").addClass("active");
  } else if (window.location.href == "https://yensa.com/blogs/news?page=27") {
    $(document).find(".uppercase-letter").addClass("active");
  } else {
  }
});

// announcement bar slider

function Hide(HideID) {
  HideID.style.display = "none";
  $("body").addClass("announcement-cart");
}

// Smooth scroll function
function smoothScroll(target) {
  const element = document.querySelector(target);
  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
    });
  }
}

// Attach smooth scroll behavior to the anchor tag
const readReviewLink = document.querySelector('a[href="#read-review"]');
if (readReviewLink) {
  readReviewLink.addEventListener("click", function (event) {
    event.preventDefault();

    const headerHeight = document.querySelector("header").offsetHeight; // Adjust the selector to match your header
    const customOffsetInPixels = 100; // Adjust this value to set your custom offset in pixels
    const targetElement = document.querySelector("#read-review");

    if (targetElement) {
      const targetPosition =
        targetElement.getBoundingClientRect().top +
        window.pageYOffset -
        headerHeight -
        customOffsetInPixels;
      const startPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      const distance = targetPosition - startPosition;
      const duration = 3000; // Adjust this value to control the scroll speed

      const startTime = performance.now();

      function step(timestamp) {
        const currentTime = timestamp || performance.now();
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        window.scrollTo(0, startPosition + distance * progress);

        if (progress < 1) {
          requestAnimationFrame(step);
        }
      }

      requestAnimationFrame(step);
    }
  });
}

// Shade Issues 30-11-23 start
// for product- super serum bundle
$(document).ready(function () {
  $(".product-super-serum-bundle .Foundation label").click(function () {
    var shadeName = $(this).data("swatch");
    $("#selectedShade").text("Shade of Foundation: " + shadeName);
  });
  $(".product-super-serum-bundle .Concealer label").click(function () {
    var shadeName = $(this).data("swatch");
    $("#selectedShades").text("Shades of Concealer: " + shadeName);
  });
});

// for product- skin on skin bundle
$(document).ready(function () {
  $(" .product-bc-bundle .BCFoundation label").click(function () {
    var shadeName = $(this).data("swatch");
    $("#selectedShade").text("Shade of Foundation: " + shadeName);
  });
  $(" .product-bc-bundle .BCConcealer label").click(function () {
    var shadeName = $(this).data("swatch");
    $("#selectedShades").text("Shades of Concealer: " + shadeName);
  });
});
// for product- super-serum-silk-set
$(document).ready(function () {
  $(" .product-super-serum-silk-set .SERUMFOUNDATION label").click(function () {
    var shadeName = $(this).data("swatch");
    $("#selectedShade").text("Shade of Foundation: " + shadeName);
  });
  $(" .product-super-serum-silk-set .SERUMCONCEALER label").click(function () {
    var shadeName = $(this).data("swatch");
    $("#selectedShades").text("Shades of Concealer: " + shadeName);
  });
});
// for pressed-to-perfection-set
$(document).ready(function () {
  $(" .product-pressed-to-perfection-set .POWDERFOUNDATION label").click(
    function () {
      var shadeName = $(this).data("swatch");
      $("#selectedShade").text("Shade of Foundation: " + shadeName);
    },
  );
  $(" .product-pressed-to-perfection-set .UNDEREYECORRECTOR label").click(
    function () {
      var shadeName = $(this).data("swatch");
      $("#selectedShades").text("Shades of Concealer: " + shadeName);
    },
  );
});

// Shade issues 30-11-23 end

//  start PDP caurosel 15-12-23
if (
  window.location.href ===
  "https://yensa.com/products/60-off-super-serum-silk-foundation"
) {
  $(document).ready(function () {
    // Get the li element by its ID
    var elements = document.querySelectorAll(".thumbnail-list__item.hidden");

    // Iterate through the elements and remove the 'hidden' class
    elements.forEach(function (element) {
      element.classList.remove("hidden");
    });
  });
}
// end PDP caurosel 15-12-23

// $(document).ready(function () {
$(document).on(
  "click",
  ".product-form__input label, .shadlist_dropdown_pdp option",
  function () {
    var inputElement = $(this).prev('input[type="radio"]');
    setTimeout(function () {
      if (
        inputElement.hasClass("active") &&
        inputElement.data("custom") === "soldout" &&
        inputElement.data("swatch") === "light-medium-1" &&
        inputElement.prop("checked")
      ) {
        $(".pdp-details-content").hide();
        $(".custom_soldout").removeClass("hidden");
      } else {
        $(".pdp-details-content").show();
        $(".custom_soldout").addClass("hidden");
      }
    }, 500);
  },
);
// });

$(document).ready(function () {
  // Define a function to check the conditions
  function checkConditions() {
    var inputElement = $('.product-form__input input[type="radio"].active');
    setTimeout(function () {
      if (
        inputElement.length &&
        inputElement.data("custom") === "soldout" &&
        inputElement.data("swatch") === "light-medium-1" &&
        inputElement.prop("checked")
      ) {
        $(".pdp-details-content").hide();
        $(".custom_soldout").removeClass("hidden");
      } else {
        $(".pdp-details-content").show();
        $(".custom_soldout").addClass("hidden");
      }
    }, 500);
  }

  // Call the function on document ready
  checkConditions();

  $(".product-form__input label").on("click", function () {
    checkConditions();
  });

  $(".shadlist_dropdown_pdp").on("change", function () {
    checkConditions();
  });
});

/* Global PDP Edit start */
$(document).ready(function () {
  $(window).on("load", function () {
    $("#upscribe-options").css("display", "block");
  });
});
/* Global PDP Edit end */

// PDP image zoom functionality start

document.addEventListener("DOMContentLoaded", function () {
  var images = document.querySelectorAll(".hover-image");

  images.forEach(function (image) {
    var container = document.createElement("div");
    container.className = "image-container";
    image.parentNode.insertBefore(container, image);
    container.appendChild(image);

    var lens = document.createElement("div");
    lens.className = "magnifying-lens";
    container.appendChild(lens);

    container.addEventListener("mousemove", function (event) {
      var boundingRect = container.getBoundingClientRect();
      var x = event.clientX - boundingRect.left;
      var y = event.clientY - boundingRect.top;

      lens.style.left = x - lens.offsetWidth / 2 + "px";
      lens.style.top = y - lens.offsetHeight / 2 + "px";

      var infoContainer = document.querySelector(
        ".product__info-wrapper .product__info-container",
      );

      var zoomOverlay = infoContainer.querySelector(".zoom-overlay");
      if (!zoomOverlay) {
        zoomOverlay = document.createElement("div");
        zoomOverlay.className = "zoom-overlay";
        infoContainer.appendChild(zoomOverlay);
      }

      var zoomedImage = zoomOverlay.querySelector(".zoomed-image");
      if (!zoomedImage) {
        zoomedImage = document.createElement("div");
        zoomedImage.className = "zoomed-image";
        zoomOverlay.appendChild(zoomedImage);
      }

      var scale = 2;
      var zoomedX = (x - lens.offsetWidth / 2) * scale;
      var zoomedY = (y - lens.offsetHeight / 2) * scale;

      var zoomedWidth = container.clientWidth * scale;
      var zoomedHeight = container.clientHeight * scale;

      zoomedImage.style.backgroundImage = 'url("' + image.src + '")';
      zoomedImage.style.backgroundSize =
        zoomedWidth + "px " + zoomedHeight + "px";
      zoomedImage.style.backgroundPosition =
        "-" + zoomedX + "px -" + zoomedY + "px";

      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      zoomOverlay.style.display = "block";
      zoomOverlay.style.width = infoContainer.offsetWidth + "px";
      zoomOverlay.style.height = 350 + "px";
      zoomOverlay.style.top = infoContainer.offsetTop - scrollTop + "px";
      zoomOverlay.style.left = infoContainer.offsetLeft + "px";
    });

    container.addEventListener("mouseleave", function () {
      var lens = container.querySelector(".magnifying-lens");
      lens.style.display = "none";

      var infoContainer = document.querySelector(
        ".product__info-wrapper .product__info-container",
      );
      var zoomOverlay = infoContainer.querySelector(".zoom-overlay");
      if (zoomOverlay) {
        zoomOverlay.style.display = "none";
      }
    });

    container.addEventListener("mouseenter", function () {
      var lens = container.querySelector(".magnifying-lens");
      lens.style.display = "block";
    });
  });

  window.addEventListener("scroll", function () {
    var infoContainer = document.querySelector(
      ".product__info-wrapper .product__info-container",
    );
    if ($(".zoom-overlay").length > 0) {
      var zoomOverlay = infoContainer.querySelector(".zoom-overlay");
      if (zoomOverlay && zoomOverlay.style.display === "block") {
        var scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        zoomOverlay.style.top = infoContainer.offsetTop - scrollTop + "px";
      }
    }
  });
});
// PDP image zoom functionality end

document.addEventListener("DOMContentLoaded", function () {
  // Function to remove role attribute from swiper-slide elements inside <li>
  function removeRoleFromSlides() {
    let slides = document.querySelectorAll("li.swiper-slide");
    slides.forEach(function (slide) {
      slide.removeAttribute("role");
    });
  }
  // Initial removal
  removeRoleFromSlides();
  // Observe changes to dynamically added content
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      removeRoleFromSlides();
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

// Global-e Integration JS Start

// Function to wait for elements to be available in the DOM
function waitForElements(selector) {
  return new Promise((resolve) => {
    function checkElements() {
      const elements = document.querySelectorAll(selector);
      if (elements.length > 0) {
        resolve(elements);
      } else {
        requestAnimationFrame(checkElements);
      }
    }
    checkElements();
  });
}

// Function to add class to elements
async function addClassToElements() {
  const yotpoSelector =
    ".yotpo-radio-container.yotpo-radio-subscription-container";
  const afterpaySelector = "square-placement";

  const yotpoElements = await waitForElements(yotpoSelector);
  const afterpayElements = await waitForElements(afterpaySelector);

  yotpoElements.forEach(function (element) {
    element.classList.add("ge-hide-display-none");
  });

  afterpayElements.forEach(function (element) {
    element.classList.add("ge-hide-display-none");
  });
}

addClassToElements();

// Function to wait for an element to be available in the DOM
function waitForElement(selector) {
  return new Promise((resolve) => {
    function checkElement() {
      const element = document.querySelector(selector);
      if (element) {
        resolve(element);
      } else {
        requestAnimationFrame(checkElement);
      }
    }
    checkElement();
  });
}

async function handleCartData(cartData) {
  if (cartData) {
    const orderProtectionItem = cartData.items.find(
      (item) => item.handle === "order-protection",
    );

    if (orderProtectionItem) {
      const price = (orderProtectionItem.price / 100).toFixed(2);
      const opPriceElement = await waitForElement("#op-price");
      opPriceElement.style.display = "none";

      // Create a new element
      const newElement = document.createElement("div");
      newElement.innerHTML = `<label id="op-price-custom" class="__op-text-black __op-mb-0" for="op-toggle">${cartData.currency} ${price}</label>`;
      opPriceElement.parentNode.insertBefore(
        newElement,
        opPriceElement.nextSibling,
      );
    } else {
      console.log('Item with handle "order-protection" not found.');
    }
  }
}

(async function () {
  const response = await fetch("/cart.js");
  const initialCartData = await response.json();
  handleCartData(initialCartData);
})();

document.addEventListener("DOMContentLoaded", function () {
  $(".shade_input").change(function () {
    var selectedValue = $(this).val();

    var productData = JSON.parse($("#variant_details").text());

    $.each(productData, function (index, product) {
      if (product.title === selectedValue && product.compare_at_price !== 0) {
        setTimeout(function () {
          var formattedComparePrice =
            "$" + (product.compare_at_price / 100).toFixed(2);
          if (formattedComparePrice != "$0.00") {
            $(".btntxt").append(
              '<span class="compare_price">' +
                formattedComparePrice +
                "</span>",
            );
          }
        }, 1000);
      }
    });
  });

  // Function to add the class to matching elements
  function addClassToElements() {
    // Select elements for all specified class names
    const yotpoElements = document.querySelectorAll(
      ".yotpo-radio-container.yotpo-radio-subscription-container",
    );
    const rebuyElements = document.querySelectorAll(
      ".rebuy-cart__progress-bar-container.above",
    );
    const afterpayElements = document.querySelectorAll("square-placement");

    // Add the "ge-hide-display-none" class to each selected element
    yotpoElements.forEach(function (element) {
      element.classList.add("ge-hide-display-none");
    });
    rebuyElements.forEach(function (element) {
      element.classList.add("ge-hide-display-none");
    });
    afterpayElements.forEach(function (element) {
      element.classList.add("ge-hide-display-none");
    });
  }

  // Run the function initially in case elements are already in the DOM
  addClassToElements();

  // Create a MutationObserver to monitor the DOM for changes
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList") {
        addClassToElements();
      }
    });
  });

  // Start observing the document for changes
  observer.observe(document.body, { childList: true, subtree: true });
});

// Global-e Integration JS End

// Remove common images from the media gallery for just two variants starts
document.addEventListener("DOMContentLoaded", function () {
  const variantRadios = document.querySelectorAll(
    'input[data-name="shade-swatches"]',
  );
  const variantsToHideFrom = ["Fearless Naked", "Rebel Rose"];

  function updateMediaGallery(selectedVariantId) {
    let commonImages = document.querySelectorAll(
      "slider-component .thumbnail-list__item img[src*='LIFESTYLE.jpg']",
    );
    console.log("commonImages", commonImages);
    console.log("selectedVariantId", selectedVariantId);
    console.log("variantsToHideFrom", variantsToHideFrom);

    commonImages.forEach((img) => {
      if (variantsToHideFrom.includes(selectedVariantId)) {
        img.closest("li").style.display = "none"; // Hide image
      } else {
        img.closest("li").style.display = ""; // Show image
      }
    });
  }

  if (variantRadios) {
    variantRadios.forEach((radio) => {
      radio.addEventListener("change", function () {
        let selectedVariantId = this.dataset.variantId || this.value.trim(); // Get selected variant ID
        updateMediaGallery(selectedVariantId);
      });

      // Check the initially selected variant on page load
      if (radio.checked) {
        updateMediaGallery(radio.dataset.variantId || radio.value.trim());
      }
    });
  }
});
